import { useDispatch, useSelector } from "react-redux";
import { releaseNoteAdded, selectAllReleaseNotes } from "./releaseNotesSlice";

const AddReleaseNoteForm = () => {

    const dispatch = useDispatch();
    const startingReleaseNotes = useSelector(selectAllReleaseNotes);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { elements } = e.currentTarget;
        const releaseNoteBody = {
            id: startingReleaseNotes.length.toString(),
            toolname: elements.releaseNoteToolname.value,
            releasenumber: elements.releaseNoteReleasenumber.value,
            releasedate: elements.releaseNoteReleasedate.value,
            dateDisplay: elements.releaseNoteDateDisplay.value,
            releasedescription: elements.releaseNoteReleasedescription.value,
        }
        startingReleaseNotes.push(releaseNoteBody);
        const form = e.currentTarget;
        try {
            dispatch(releaseNoteAdded(releaseNoteBody));
            form.reset();
        } catch (err) {
            console.error("Failed to save the update: ", err);
        }
    }

    //editing in progress
    return <div>
    <h2>Add a New Release Note Entry</h2>
    <form onSubmit={handleSubmit}>
        <label htmlFor="releaseNoteToolname">Tool Name</label>
        <input type="text" style={{width: "700px"}} id="releaseNoteToolname" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteReleasenumber">Release Number</label>
        <input type="text" id="releaseNoteReleasenumber" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteReleasedate">Date (YYYY-MM-DD)</label>
        <input type="text" id="releaseNoteReleasedate" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteDateDisplay">Date Display (Month D, YYYY)</label>
        <input type="text" id="releaseNoteDateDisplay" defaultValue="" required />
        <br/>
        <label htmlFor="releaseNoteReleasedescription">Description</label>
        <input type="text" style={{width: "1700px"}}  id="releaseNoteReleasedescription" defaultValue="" required />
        <br/>
        <button>Add Entry</button>
    </form>
</div>
}

export default AddReleaseNoteForm;